import { get } from './';

const getEnvironment = () => get('/environment');

const environmentApi = {
  getEnvironment,
};

export default environmentApi;
